import Vue from 'vue'
import VueRouter from 'vue-router'

import home from './home'
import login from './login'
import changePassword from './changePassword'

import department from './department'

import personnel from './personnel'
import personnelAdd from './personnel/personnelAdd'

import place from './place'
import placeAdd from './place/placeAdd'

import routers from './routers'
import routersAdd from './routers/routersAdd'

import task from './task'
import taskAdd from './task/taskAdd'

import inspection from './inspection'
import inspectionMsg from './inspection/inspectionMsg'

import abnormal from './abnormal'
import abnormalMsg from './abnormal/abnormalMsg'

import fault from './fault'
import faultMsg from './fault/faultMsg'

import taskPanel from './taskPanel'
import wholeTaskPanel from './taskPanel/wholeTaskPanel'

import operationLog from './operationLog'

const VueRouterPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(to) {

    return VueRouterPush.call(this, to).catch(err => err)

}

Vue.use(VueRouter)

const routes = [
    home,
    login,
    changePassword,
    department,
    personnel,
    personnelAdd,
    place,  //点位管理
    placeAdd,
    routers,//路线管理
    routersAdd,
    task,
    taskAdd,
    inspection, //巡检记录
    inspectionMsg,
    abnormal,
    abnormalMsg,
    fault,      //故障处理
    faultMsg,
    taskPanel,  //任务看板
    wholeTaskPanel,
    operationLog
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
